import { 
	getWebcastCommunities,
	getChannelCommunities,
	setWebcastCommunities,
	getChannelPrimaryCommunityName,
	getChannelSecondaryCommunitiesName,
	getAllCommunities,
	getCommunityOptions,
	getChannelPrimaryCommunity,
	setChannelCommunities,
	getChannelSecondaryCommunities,
	getChannelPrimaryCommunityEnabled,
	getChannelSecondaryCommunitiesEnabled,
	getChannelSecondaryCommunitiesIds
} from './communities'

export default {
	getWebcastCommunities,
	getChannelCommunities,
	setWebcastCommunities,
	getChannelPrimaryCommunityName,
	getChannelSecondaryCommunitiesName,
	getAllCommunities,
	getCommunityOptions,
	getChannelPrimaryCommunity,
	setChannelCommunities,
	getChannelSecondaryCommunities,
	getChannelPrimaryCommunityEnabled,
	getChannelSecondaryCommunitiesEnabled,
	getChannelSecondaryCommunitiesIds
}
